import React from 'react';

const CodeBlock = ({ blok }) => {
  return (
    <div className="max-w-7xl mx-auto px-6 lg:my-40 md:32 my-16 code" dangerouslySetInnerHTML={{__html: blok.code}}></div>
  );
}

export default CodeBlock;